import styled from '@emotion/styled';
import LinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';
import { getMymeProgress } from 'src/utils';
import { Box, Typography } from 'src/components/atoms';
import { FlexColumn } from 'src/components/layout';

interface Props extends LinearProgressProps {
  value: number;
}

const StyledLinearProgress = styled(LinearProgress)(
  ({ theme }) => `
    height: 100%;
    border-radius: 1rem;
    background-color: ${theme.palette.common.white};
`
);

const StyledText = styled(Typography)`
  align-self: flex-end;
  margin-top: 0.5rem;
  margin-right: 0.25rem;
  font-size: 12px;
`;

export const MymePreviewProgressBar = ({ value, ...props }: Props) => {
  const formattedProgress = getMymeProgress(value);

  return (
    <FlexColumn width='100%' maxWidth='20rem'>
      <Box width='100%' height='0.25rem'>
        <StyledLinearProgress value={formattedProgress.value} variant='determinate' color='primary' {...props} />
      </Box>

      <StyledText variant='body2'>{formattedProgress.text}</StyledText>
    </FlexColumn>
  );
};
